import { Component } from '@angular/core';

@Component({
  selector: 'app-protect-pdf-content',
  imports: [],
  templateUrl: './protect-pdf-content.component.html',
  styleUrl: './protect-pdf-content.component.css'
})
export class ProtectPdfContentComponent {

}
